import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="image, heading, text1, text2" width="33%" theme="lightest" className="align-left icon-xl-size padding-top-zero horizontal-align-heading link py-0 easy-to-implement-cta" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/764f73d9840509f01ce57856e1a98a0d/3_Icon_Easy.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "easy-to-implement"
    }}>{`Easy to implement.`}</h3>
    <p>{`Acrobat Sign service features are available via easy-to-use REST APIs. Integrate e-signatures into your platform, application, or workflow in a snap.`}</p>
    <p><a parentName="p" {...{
        "href": "https://secure.na1.adobesign.com/public/docs/restapi/v6"
      }}>{`Learn more`}</a></p>
    <TextBlock slots="image, heading, text1, text2" width="33%" theme="lightest" className="align-left icon-xl-size padding-top-zero horizontal-align-heading link py-0 secure-compliant-cta" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/bb8672b6390a6788f048fada82abf241/3_Icon_Secure.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "secure-and-compliant"
    }}>{`Secure and compliant.`}</h3>
    <p>{`Acrobat Sign meets or exceeds industry security standards such as Auth v2.0 for authentication. And with our Microsoft Power Automate connector, low-code e-signature
automation is a reality.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.adobe.com/content/dam/cc/en/security/pdfs/AdobeSign_SecurityOverview.pdf"
      }}>{`Learn more`}</a></p>
    <TextBlock slots="image, heading, text1, text2" width="33%" theme="lightest" className="align-left icon-xl-size padding-top-zero horizontal-align-heading link py-0 scalable-cta" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/391e5258e8f0c50729dfb7215d3807ec/3_Icon_Scalable.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "scalable"
    }}>{`Scalable.`}</h3>
    <p>{`Our global data centers are resilient and designed to deliver high availability. Acrobat Sign scales and adapts to meet a variety of unique needs and workflows.       `}</p>
    <p><a parentName="p" {...{
        "href": "https://helpx.adobe.com/sign/using/adobesign-data-centers.html"
      }}>{`Learn more`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      